import { normalizeDateStrForDB } from "@base/components/input/base/utils";
import type { GridConfig } from "@/types/grid";
import type { BulkImportPageSetupStatic } from "@/types/bulk-import";

export const getProductionLinesPageConfig =
  (): BulkImportPageSetupStatic<ProductionLineSchema> => ({
    id: "production-lines",
    pageTitle: "cksetup.imports.production-lines.pageTitle",
    pageHeading: "cksetup.imports.production-lines.heading",
    learnMoreTitle: "cksetup.imports.production-lines.learnMoreTitle",
    learnMoreText: "cksetup.imports.production-lines.learnMoreText",
    templateFileName: "cksetup.imports.production-lines.templateName",
    templateWorksheetName: "tableColumns.productionLines.worksheetName",
    tabTitle: "cksetup.imports.bulk.productionLinesHeading",
    tabDescription: "cksetup.imports.bulk.productionLinesDescription",
    imageSrc: "/static/images/bulk/production-lines.png",
    validationSchema: productionLineSchema,
    addButtonLabel: "cksetup.imports.production-lines.addNewProductionLine",
  });

export const getProductionLinesGridConfig = async (): Promise<
  GridConfig<ProductionLineSchema>
> => {
  return {
    defaultRowData: {
      active: true,
      gmp: true,
    },
    computeItemFn: (item) => {
      // Since we are not using ZodForm, we force the DB normalization when computing each item
      return {
        ...item,
        dateInstalled: normalizeDateStrForDB(item.dateInstalled),
      };
    },
    columns: [
      {
        field: "number",
        alternativeMappingNames: ["id"],
        hidden: true,
        isKey: true,
        propagateErrorsTo: "name",
      },
      {
        field: "name",
        title: "tableColumns.productionLines.name",
        helperText: "tableColumns.productionLines.nameColumnHelperText",
        placeholder: "tableColumns.enterName",
        editor: "text",
      },
      {
        field: "active",
        title: "tableColumns.activeColumnLabel",
        alternativeMappingNames: ["isActive"],
        helperText: "tableColumns.productionLines.activeColumnHelperText",
        editor: "boolean",
      },
      {
        field: "gmp",
        title: "tableColumns.productionLines.gmpColumnLabel",
        helperText: "tableColumns.productionLines.gmpColumnHelperText",
        editor: "boolean",
      },
      {
        field: "location",
        title: "tableColumns.location",
        helperText: "tableColumns.productionLines.locationColumnHelperText",
        editor: "text",
        placeholder: "tableColumns.enterLocation",
        required: false,
      },
      {
        field: "dateInstalled",
        title: "tableColumns.dateInstalledColumnLabel",
        helperText:
          "tableColumns.productionLines.dateInstalledColumnHelperText",
        placeholder: "tableColumns.datePlaceholder",
        editor: "date",
        editorProps: {
          modelModifiers: {
            string: true,
          },
        },
      },
      {
        field: "comments",
        title: "tableColumns.commentsColumnLabel",
        helperText: "tableColumns.productionLines.commentsColumnHelperText",
        editor: "text",
        placeholder: "tableColumns.enterComments",
        required: false,
      },
    ],
  };
};
